module.exports = __webpack_public_path__ + "static/img/store-logo1.9893f669.png";